import getBaseDomainWithoutApp from "utils/getBaseDomainWithoutApp";

const STAGEPANDA_DOMAIN = "stagepanda.com";
const STAGE_CV_DOMAIN = "stage.cv";

/**
 * Builds a URL on a user's public speaker page.
 *
 * The public page lives on the user's own subdomain (e.g. https://nana24.stage.cv),
 * which is a different host from the admin app. On localhost there are no
 * subdomains, so the user travels as a `?username=` query param instead.
 *
 * @param path a path on the public page, e.g. "/book" or `/book/${bookingId}`.
 *             Defaults to the profile root.
 */
export default function getPublicProfileUrl(username: string, path = "") {
  const { hostname, port, protocol } = window.location;

  const normalizedPath =
    !path || path === "/" ? "" : path.startsWith("/") ? path : `/${path}`;

  if (hostname.includes("localhost") || hostname === "127.0.0.1") {
    const portSuffix = port ? `:${port}` : "";
    return `${protocol}//${hostname}${portSuffix}${
      normalizedPath || "/"
    }?username=${encodeURIComponent(username)}`;
  }

  const baseDomain = getBaseDomainWithoutApp();
  const resolvedDomain =
    baseDomain === STAGEPANDA_DOMAIN ? STAGE_CV_DOMAIN : baseDomain;

  return `https://${username}.${resolvedDomain}${normalizedPath}`;
}
